export const TABS = [
  'Обработка аудиозаписи',
  'Информация о заседании',
  'Работа с каналами',
];
